var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('span',{staticClass:"scroller__dot",class:{
      'scroller__dot--active': _vm.activePosition === 1,
      'scroller__dot--reduce': _vm.isFirstDotReduced
    }}),(_vm.picturesLength >= 4)?_c('span',{staticClass:"scroller__dot",class:{
      'scroller__dot--active': _vm.isAfterFirstDotActived
    }}):_vm._e(),(_vm.picturesLength === 3 || _vm.picturesLength >= 5)?_c('span',{staticClass:"scroller__dot",class:{ 'scroller__dot--active': _vm.isMiddleDotActived }}):_vm._e(),(_vm.picturesLength >= 4)?_c('span',{staticClass:"scroller__dot",class:{
      'scroller__dot--active': _vm.isBeforeLastDotActived
    }}):_vm._e(),_c('span',{staticClass:"scroller__dot",class:{
      'scroller__dot--active': _vm.activePosition === _vm.picturesLength,
      'scroller__dot--reduce': _vm.isLastDotReduced
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }